import { render, staticRenderFns } from "./vita.vue?vue&type=template&id=c6365458&scoped=true&"
import script from "./vita.vue?vue&type=script&lang=js&"
export * from "./vita.vue?vue&type=script&lang=js&"
import style0 from "./vita.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./vita.vue?vue&type=style&index=1&id=c6365458&lang=stylus&scoped=true&"
import style2 from "./vita.vue?vue&type=style&index=2&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6365458",
  null
  
)

export default component.exports